export default __webpack_public_path__ + "static/media/2680508E-1E18-444D-87AB-96347C53031B.e25da59a.jpeg";